<style src="./ModalContentStatus.scss" lang="scss"></style>
<template>
  <div class="modal-body ModalContentStatus">  
    <div class="photos">
      <ModalZoom
        v-for="(photoPath, idx) in item.credit.vehiclePhotoPath"
        :key="idx"
        :photo="sanitizePhotoPath(photoPath)" />
    </div>
    <div class="info">
      <div class="posutilizacao">
        <h2>Dados da Pós Utilização</h2>
        <table class="table">
          <tbody>
            <tr class="tableData">
              <td class="tableTitle">Data da Ocorrência</td>
              <td class="tableValue">{{ DateBR(item.createdAt) }} - {{ HourBR(item.createdAt) }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Setor</td>
              <td class="tableValue">{{ item.localDescricao }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Valor R$</td>
              <td class="tableValue">{{ totalToCurrencyBR(item.credit.amountPaid) }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Fiscal</td>
              <td class="tableValue">{{ item.credit.employee.fullName }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Cód. Crédito</td>
              <td class="tableValue">{{ item.credit.creditCode }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="vehicleinfo">
        <h2>Dados do Veículo</h2>
        <table class="table">
          <tbody>
            <tr class="tableData">
              <td class="tableTitle">UF</td>
              <td class="tableValue">{{ item.veiculoUf || '-' }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Tipo</td>
              <td class="tableValue">{{ item.veiculoEspecie || '-' }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Marca/Modelo</td>
              <td class="tableValue">{{ item.veiculoMarcaModelo || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="history">
      <h2>Detalhes da Infração</h2>
      <table class="table">
        <tbody>
          <tr class="tableData">
            <td class="tableTitle">Numero AIT</td>
            <td class="tableValue">{{ item.numeroAuto || '-' }}</td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Data do Envio</td>
            <td class="tableValue">
              {{ DateBR(item.createdAt) }} - {{ HourBR(item.createdAt) }}
            </td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Condutor Situação</td>
            <td class="tableValue">{{ item.condutorSituacao || '-' }}</td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Código da Infração</td>
            <td class="tableValue">{{ item.tipoInfracaoCodigo || '-' }}</td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Infração Desdobramento</td>
            <td class="tableValue">{{ item.tipoInfracaoDesdobramento || '-' }}</td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Observação</td>
            <td class="tableValue">{{ item.observacao || '-' }}</td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Enviado Por</td>
            <td class="tableValue">{{ item.user && item.user.fullName || 'Não Identificado' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="error" v-if="item.status === 2">
        <h2>Detalhes do Erro</h2>
        <pre class="errorCode">{{ errorDetailed }}</pre>
      </div>
    </div>

  </div>
</template>

<script>
import ModalZoom from '../modal-zoom/ModalZoom.vue';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export default {
  components: {
    ModalZoom,
  },
  props: {
    item: {
      default: () => ({})
    },
  },
  data() {
    return {
      invalidReason: '',
      validState: 0,
      creditHistory: [],
      isLoadingVehicleDetails: false,
      isLoadingHistory: true,
      form: {
        infracaoCodigo: '',
        infracaoDesdobramento: '',
        observacao: '',
        condutorSituacao: '5'
      }
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newItem) {
        const form = {
          infracaoCodigo: newItem.infracaoCodigo,
          infracaoDesdobramento: newItem.infracaoDesdobramento,
          observacao: newItem.observacao
        };
        this.$emit('input', form);
      }
    }
  },
  computed: {
    errorDetailed() {
      if (this.item.statusErrorDescription && this.item.statusErrorDescription.length > 0) {
        const parsedJSON = JSON.parse(this.item.statusErrorDescription)
        return JSON.stringify(parsedJSON, null, 2);
      }

      return 'Sem Erro';
    }
  },
  mounted () {
    this.loadVehicleDetailsIfNecessary();
    this.loadVehicleHistory();
    this.setDefaultCodes();
    this.$refs.inputInfracaoCodigo.focus();
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      if (!dt) return null;
      return format(new Date(dt), 'dd/MM/yyyy', {
        locale: ptBR,
      });
    },
    HourBR(dt) {
      if (!dt) return null;
      return format(new Date(dt), 'HH:mm', {
        locale: ptBR,
      });
    },
    setDefaultCodes() {
      this.form.condutorSituacao = this.$store.state.SERPRO.defaultCondutorSituacao || '';
      this.form.infracaoCodigo = this.$store.state.SERPRO.defaultInfracaoCodigo || '';
      this.form.infracaoDesdobramento = this.$store.state.SERPRO.defaultInfracaoDesdobramento || '';
      this.form.observacao = this.$store.state.SERPRO.defaultObservacao || '';
    },
    loadVehicleDetailsIfNecessary() {
      if (!Object.hasOwn(this.item.vehicleDetails, 'uf')) {
        this.refreshVehicleDetails();
      }
    },
    closeModal() {
      this.$emit('close-modal');
    },
    async refuseValidation() {
      this.validState = 2;
      await this.$nextTick();
      this.$refs.inputReason.focus();
    },
    cancelValidation() {
      this.validState = 0;
    },
    setValidState(state) {
      this.validState = state;
    },
    confirmValidation() {
      this.validState = 0;
    },
    confirmRefuse() {
      this.invalidReason = '';
      this.validState = 0;
    },
    sanitizePhotoPath(photoPath) {
      let photoPathSanitized = photoPath.replace(
        '/var/app/server-user-manager/notify-photos/',
        '',
      );
      photoPathSanitized = photoPath.replace(
        '/var/app/server-manager/notify-photos/',
        '',
      );

      const prodPath = 'https://peaceparking.app:3000/'
      return prodPath + photoPathSanitized;
    },
  },
};
</script>
